import * as React from 'react';
import { SchoolEvent, SchoolEventIndividualData } from 'Src/models/event';
import { isEventStatusFinished } from '../../../../../../helpers/event/event';
import {
  convertPointsToStringWithoutDelimeter,
  getExtraPointsByStudent,
  getIndividualScoreByStudent,
  getAbbreviationResultByStudent,
  getAbbreviationColor
} from '../../../../../../helpers/event/schoolEventViewHelper';
import { Report } from 'Src/models/report';
import moment from 'moment';
import { AvailabilityStatusDot } from 'Src/components/AvailabilityStatusDot/AvailabilityStatusDot';

interface Props {
  players: SchoolEventIndividualData[];
  event: SchoolEvent;
  availabilityReports?: Report[];
  availabilitySelfService?: boolean;
}

export function SchoolEventIndividualPlayers(props: Props) {
  const showAvailability = props.availabilityReports !== undefined;
  const { players, event, availabilityReports = [] } = props;
  const availabilityByPermission = availabilityReports.reduce((result, report) => {
    const key = String(report.playerDetails?.permissionId || '');
    const previous = result.get(key);
    if (key && (!previous || moment(report.createdAt).isAfter(moment(previous.createdAt)))) result.set(key, report);
    return result;
  }, new Map<string, Report>());

  const hasPositiveExtraPoints = players.some(player => {
    const extraPoints = getExtraPointsByStudent(event, player.userId);
    return extraPoints > 0;
  });

  const rows = players.map((player, playerIndex) => {
    const { userId, permissionId } = player;
    const playerPoints = getIndividualScoreByStudent(event, userId, permissionId);
    const playerPointsStr = convertPointsToStringWithoutDelimeter(event, playerPoints);
    const extraPoints = getExtraPointsByStudent(event, userId);
    const extraPointsStr = String(extraPoints);
    const abbreviationResult = getAbbreviationResultByStudent(event, userId, permissionId) || '';
    const abbreviationColor = abbreviationResult ? getAbbreviationColor(event, abbreviationResult) : '';
    const isEventFinished = isEventStatusFinished(event);
    const isShowPoints = isEventFinished || Boolean(playerPoints);
    const isShowExtraPoints = isEventFinished || Boolean(extraPoints);
    const availability = availabilityByPermission.get(String(permissionId));

    return (
      <tr key={`school_players_${player.id}`}>
        <td style={{ width: '5%' }}>{playerIndex + 1}</td>
        <td style={{ width: '25%' }}>{player.firstName}</td>
        <td style={{ width: '25%' }}>{player.lastName} {showAvailability ? <AvailabilityStatusDot report={availability} selfService={props.availabilitySelfService} /> : null}</td>
        <td style={{ width: '25%' }}>{isShowPoints && <span className="font-weight-bold">{playerPointsStr}</span>}</td>
        <td style={{ width: '10%' }}>
          {isShowExtraPoints && hasPositiveExtraPoints && <span className="font-weight-bold">{extraPointsStr}</span>}
        </td>
        <td style={{ width: '10%', color: abbreviationColor }}>
          {abbreviationResult && <span className="font-weight-bold">{abbreviationResult}</span>}
        </td>
      </tr>
    );
  });

  return (
    <table className="w-100">
      <tbody>{rows}</tbody>
    </table>
  );
}
